import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import caretDown from '../../../../assets/images/icons/caret-down.svg';
import { isMobile } from '../../../screenUtils';
function DropdownIndicator(props) {
  var menuIsOpen = props.selectProps.menuIsOpen;
  var customStyle = {
    transform: menuIsOpen ? 'rotate(180deg)' : undefined,
    marginTop: '8px',
    marginBottom: '8px',
    marginRight: isMobile() ? '2px' : '8px',
    marginLeft: isMobile() ? '-6px' : 0
  };
  return /*#__PURE__*/React.createElement(components.DropdownIndicator, props, /*#__PURE__*/React.createElement("img", {
    src: caretDown,
    alt: "caret-down",
    style: customStyle
  }));
}
DropdownIndicator.propTypes = {
  selectProps: PropTypes.shape({
    menuIsOpen: PropTypes.bool
  })
};
DropdownIndicator.defaultProps = {
  selectProps: {}
};
export default DropdownIndicator;